import * as React from 'react';
import s from './PriceQuoteLoader.scss';
import { Text, Loader, Heading } from 'wix-style-react';
import { translate } from 'react-i18next';
var PriceQuoteLoader = function (_a) {
    var t = _a.t;
    return (React.createElement("div", { className: s.container },
        React.createElement("div", { className: s.loader },
            React.createElement(Loader, { size: "large" })),
        React.createElement("div", { className: s.heading },
            React.createElement(Heading, null, t('invoice-view:price_quote.loader.heading'))),
        React.createElement(Text, null, t('price_quote.loader.message'))));
};
export default translate(['invoice-view', 'locale-data'], { wait: true })(PriceQuoteLoader);
//# sourceMappingURL=PriceQuoteLoader.js.map